import { EPromoLabelType } from '../types/promos/promoLabel';

export const SEO_LABEL_TYPES = [EPromoLabelType.Mortgage, EPromoLabelType.Bonus, EPromoLabelType.Discount];

export const SEO_ACTION_TEXT = 'Оформить заявку';
